import { render, staticRenderFns } from "./myShareMore.vue?vue&type=template&id=40b9c32e&scoped=true"
import script from "./myShareMore.vue?vue&type=script&lang=js"
export * from "./myShareMore.vue?vue&type=script&lang=js"
import style0 from "./myShareMore.vue?vue&type=style&index=0&id=40b9c32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9c32e",
  null
  
)

export default component.exports